import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "../api.service";
import { HandlerService } from "../handler.service";
import { AuthService } from "../auth.service";
import { DomSanitizer } from "@angular/platform-browser";
import { PdfService } from "../pdf.service";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { PaymentService } from "../payment.service";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { TranslateService } from "@ngx-translate/core";
import { LocationService } from "../location.service";
import { BottomSheet } from "../bottom.sheet";
import { objectify } from "tslint/lib/utils";
let k = 1;
@Component({
  selector: "app-mybooking",
  templateUrl: "./mybooking.component.html",
  styleUrls: ["./mybooking.component.scss"],
})
export class MybookingComponent {
  loader: boolean = true;
  cancelStatus;
  rescheduleId;
  fdateCheck;
  id;
  changeDate: boolean = false;
  startdate;
  minDate = new Date();
  fDate;
  slotDate;
  url;
  requests;
  dateFormat;
  search: any = [];
  items: any = [];
  purchaseItems: any = [];
  savedItems: any = [];
  savedOrderList: any = [];
  savesPop: boolean = false;
  subsItems;
  cancelledReasons;
  cancelId;
  cancellation;
  Subscription: any = [];
  change: boolean = false;
  cateId = 21;
  Orgid;
  pModel;
  pIdentity;
  pColor;
  pName;
  pMake;
  serviceInc: boolean;
  confirm: boolean;
  orderText: boolean = false;
  confirmSubs: boolean;
  date = new Date();
  Paymentpop: boolean = false;
  category;
  purchaseCategory;
  paymentDetails: any;
  cateName;
  filterDate;
  availableSlots = [];
  availSlot: boolean;
  filterLength;
  pDate;
  payAmt;
  paymentActivity;
  monthObj: any = [
    { id: 1, name: "JAN" },
    { id: 2, name: "FEB" },
    { id: 3, name: "MAR" },
    { id: 4, name: "APR" },
    { id: 5, name: "MAY" },
    { id: 6, name: "JUN" },
    { id: 7, name: "JUL" },
    { id: 8, name: "AUG" },
    { id: 9, name: "SEP" },
    { id: 10, name: "OCT" },
    { id: 11, name: "NOV" },
    { id: 12, name: "DEC" },
  ];
  categoryId;
  slots;
  slot;
  Oid;
  endTime;
  slotClicked: boolean;
  openSlot: boolean = false;
  rescheduleOrd: boolean = false;
  enddate;
  fontStyle;
  toggle: boolean = true;
  notLoged: boolean;
  time = "Time";
  pageNum: boolean = true;
  pageNumLoader: boolean = false;
  constructor(
    private service: ApiService,
    public handler: HandlerService,
    public pdf: PdfService,
    public bottomSheet: MatBottomSheet,
    public router: Router,
    public payment: PaymentService,
    public translate: TranslateService,
    private iab: InAppBrowser,
    public auth: AuthService,
    public location: LocationService
  ) {}

  ionViewWillEnter() {
    k = 1;
    this.loader = true;
    this.changeDate = false;
    this.dateFormat = this.auth.getDateformat();
    this.blockDate();
    this.url = window.location.href;
    if (this.url.includes("savedOrders")) {
      this.savesPop = true;
    } else {
      this.savesPop = false;
    }

    this.id = localStorage.getItem("currentUserId");
    if (this.url.includes("myrequests") || this.url.includes("myrequests1")) {
      this.toggle = false;
    }
    if (
      this.url.includes("mySubscriptions") ||
      this.url.includes("mySubscriptions1")
    ) {
      if (this.auth.loged()) {
        this.getSubs();
        this.toggle = false;
        this.change = true;
      } else {
        this.loader = false;
        this.toggle = false;
        this.change = true;
      }
    } else {
      if (this.auth.loged()) {
        // this.getAllOrder();
        this.notLoged = false;
        this.getCategory();
      } else {
        this.notLoged = true;
        this.loader = false;
      }
    }
    this.getCancelReason();
  }

  returnDate1(data) {
    let date = data.getDate();
    date = date < 10 ? "0" + date : date;
    let month = data.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let year = data.getFullYear();
    return date + "-" + month + "-" + year;
  }

  startDate() {
    this.fDate = this.returnDate(this.startdate);
    this.slotDate = this.returnDate1(this.startdate);
    this.time = "Time";
  }

  cancelOrder(id, data) {
    this.cancelId = id;
    this.cancelStatus = data;
    this.confirm = true;
  }

  getPurCategory() {
    this.service.getAllDetailedPurchaseCategory().subscribe((res: any) => {
      if (res) {
        this.purchaseCategory = res;
      }
    });
  }

  reschedule(id) {
    this.rescheduleId = id;
    this.rescheduleOrd = true;
  }

  setTime(data) {
    this.time = data.startTime;
    this.endTime = data.endTime;
    this.slot = data;
    this.slotClicked = false;
    this.openSlot = false;
    this.changeDate = true;
  }

  getAllOrder() {
    this.loader = true;
    this.change = false;
    if (this.auth.loged()) {
      this.service.getAllOrderByCustomerId(this.id, k).subscribe(
        (res: any) => {
          if (res) {
            this.items = res;
            this.purchaseItems = res;
            this.savedItems = res;
            this.savedOrderList = res;

            // this.purchaseItems = this.purchaseItems.filter(res=>{return (res.status==7 || res.status==2|| res.status==4|| res.status==5 || res.status==6)&&res.orderType==2  })
            this.items = this.items.filter((res) => {
              return (
                (res.status == 7 ||
                  res.status == 3 ||
                  res.status == 10 ||
                  res.status == 12 ||
                  res.status == 9 ||
                  res.status == 5 ||
                  res.status == 11) &&
                res.orderType == 1
              );
            });
            // this.savedItems = this.savedItems.filter(res=>{return res.status==1 && res.apptDate && res.itemOrders.length != 0 && res.orderType==2})
            this.savedOrderList = this.savedOrderList.filter((res) => {
              return (
                res.status == 1 &&
                res.apptDate &&
                res.itemOrders.length != 0 &&
                res.orderType == 1
              );
            });

            this.items.map((dat) => {
              this.category.map((dat1) => {
                if (dat1.id == dat.categoryId) {
                  Object.assign(dat, { cateName: dat1.name });
                }
              });
            });

            this.savedOrderList.map((res1) => {
              this.category.map((res2) => {
                if (res2.id == res1.categoryId) {
                  Object.assign(res1, { cateName: res2.name });
                }
              });
            });
            this.purchaseItems.map((dat2) => {
              if (this.purchaseCategory) {
                this.purchaseCategory.map((dat3) => {
                  if (dat3.id == dat2.categoryId) {
                    Object.assign(dat2, { cateName: dat3.name });
                  }
                });
              }
            });
            this.savedItems.map((dat4) => {
              if (this.purchaseCategory) {
                this.purchaseCategory.map((dat5) => {
                  if (dat5.id == dat4.categoryId) {
                    Object.assign(dat4, { cateName: dat5.name });
                  }
                });
              }
            });

            this.loader = false;
            k++;
          } else {
            this.items = [];
            this.loader = false;
            this.handler.res("No Data Found");
          }
        },
        (err) => {
          this.loader = false;
          this.handler.err(err);
        }
      );
    }
    this.loader = false;
  }

  getAllOrderByPage($event) {
    if (this.search == "" || this.search == undefined) {
      this.change = false;
      if (this.auth.loged()) {
        if (this.pageNum) {
          this.pageNumLoader = true;
          this.pageNum = false;
          this.service.getAllOrderByCustomerId(this.id, k).subscribe(
            (res: any) => {
              if (res) {
                this.purchaseItems = res;
                this.savedItems = res;
                // this.purchaseItems = this.purchaseItems.filter(res=>{return (res.status==7 || res.status==2|| res.status==4|| res.status==5 || res.status==6)&&res.orderType==2  })
                var itemsArray = [];
                itemsArray = res.filter((res) => {
                  return (
                    (res.status == 7 ||
                      res.status == 3 ||
                      res.status == 10 ||
                      res.status == 12 ||
                      res.status == 9 ||
                      res.status == 5 ||
                      res.status == 11) &&
                    res.orderType == 1
                  );
                });
                itemsArray.map((dat) => {
                  this.items.push(dat);
                });
                // this.savedItems = this.savedItems.filter(res=>{return res.status==1 && res.apptDate && res.itemOrders.length != 0 && res.orderType==2});
                var savedOrderListArray = [];
                savedOrderListArray = res.filter((res) => {
                  return (
                    res.status == 1 &&
                    res.apptDate &&
                    res.itemOrders.length != 0 &&
                    res.orderType == 1
                  );
                });
                savedOrderListArray.map((dat) => {
                  this.savedOrderList.push(dat);
                });
                this.items.map((dat) => {
                  this.category.map((dat1) => {
                    if (dat1.id == dat.categoryId) {
                      Object.assign(dat, { cateName: dat1.name });
                    }
                  });
                });

                this.savedOrderList.map((res1) => {
                  this.category.map((res2) => {
                    if (res2.id == res1.categoryId) {
                      Object.assign(res1, { cateName: res2.name });
                    }
                  });
                });
                this.purchaseItems.map((dat2) => {
                  if (this.purchaseCategory) {
                    this.purchaseCategory.map((dat3) => {
                      if (dat3.id == dat2.categoryId) {
                        Object.assign(dat2, { cateName: dat3.name });
                      }
                    });
                  }
                });
                this.savedItems.map((dat4) => {
                  if (this.purchaseCategory) {
                    this.purchaseCategory.map((dat5) => {
                      if (dat5.id == dat4.categoryId) {
                        Object.assign(dat4, { cateName: dat5.name });
                      }
                    });
                  }
                });

                this.loader = false;
                k++;
                // this.pageNum = true;
                this.pageNumLoader = false;
                setTimeout(() => {}, 5000);
              } else {
                this.items = [];
                this.loader = false;
                this.handler.res("No Data Found");
                this.pageNumLoader = false;
              }
            },

            (err) => {
              // this.loader = false;
              // this.pageNumLoader = false;
              // this.handler.err(err)
            }
          );
        }
      }
      // this.loader=false;
    }
  }

  tracker(id) {
    this.router.navigate(["dailyreport/", +id]);
  }

  getCategory() {
    this.service.getOrgCategory().subscribe((res: any) => {
      this.category = res;
      if (!this.change) {
        this.getPurCategory();
        this.getAllOrder();
      }
    });
  }

  getSubs() {
    this.loader = true;
    this.change = true;
    this.url = window.location.href;
    k = 1;
    if (this.auth.loged()) {
      this.service.getCustomerItemSubs(this.id).subscribe(
        (res: any) => {
          if (res) {
            this.Subscription = res;
            this.categoryId = res.categoryId;
            this.Subscription.map((dat) => {
              if (dat.paymentDetails) {
                dat.paymentDetails.map((dat1) => {
                  this.monthObj.map((dat2) => {
                    if (dat1.month == dat2.id) {
                      Object.assign(dat1, { monthName: dat2.name });
                    }
                  });
                });
              }
            });
            this.loader = false;
          } else {
            this.Subscription = [];
            this.handler.res("No Data Found");
            this.loader = false;
          }
        },
        (err) => {
          this.loader = false;
          this.handler.err(err);
        }
      );
    }
    // this.loader= false;
    this.getCategory();
  }

  getId1(data) {
    if (data.custItems) {
      if (data.custItems[0]) {
        return data.custItems[0]?.identificationNo;
      }
    }
  }

  getId(data) {
    if (data.custItem) {
      if (data.custItem) {
        return data.custItem?.identificationNo;
      }
    } else {
      return data.identificationNumber;
    }
  }

  refreshData(event) {
    if (!this.change) {
      this.ionViewWillEnter();
    } else {
      this.getSubs();
    }

    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }

  ionViewWillLeave() {
    this.search = "";
    k = 1;
    this.loader = true;
  }

  cancelPop() {
    this.loader = false;
    this.confirm = false;
  }

  cancel(id) {
    this.cancelId = id;
    this.confirm = true;
  }

  cancelReq() {
    this.loader = true;
    this.service.cancelReqCust(this.cancelId).subscribe((res: any) => {
      this.handler.res("Request Cancelled successfully");
      this.confirm = false;
      this.router.navigate(["/manage-ondemand-req"]);
    });
  }

  clear() {
    this.search = "";
  }

  ngDoCheck(): void {
    this.filterLength = sessionStorage.getItem("len");
  }

  returnDate(data) {
    let date = data.getDate();
    date = date < 10 ? "0" + date : date;
    let month = data.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let year = data.getFullYear();
    return year + "-" + month + "-" + date;
  }

  cancelSubs(id) {
    this.cancelId = id;
    this.confirmSubs = true;
  }

  cancelSubscription() {
    this.loader = true;
    var post = {
      endDate: this.returnDate(this.enddate),
    };
    this.service.cancelPackageReq(this.cancelId, post).subscribe((res: any) => {
      this.handler.res("Subscription Cancelled successfully");
      this.confirmSubs = false;
      this.ionViewWillEnter();
    });
  }

  cancelSubsPop() {
    this.loader = false;
    this.confirmSubs = false;
    this.enddate = "";
  }

  viewBooking(id, data) {
    sessionStorage.setItem("orderType", data);
    this.loader = true;
    this.router.navigate(["booking-details/", +id]);
  }

  viewBooking1(id) {
    this.router.navigate(["booking-details1/", +id]);
  }

  pay(id1, data) {
    sessionStorage.setItem("year", data.year);
    sessionStorage.setItem("month", data.month);
    sessionStorage.setItem("PayCost", this.payAmt);
    this.router.navigate(["payment-subs/", id1]);
  }

  getCancelReason() {
    this.service.getorderCancelReason().subscribe((res) => {
      this.cancelledReasons = res;
    });
  }

  clearArray2(value) {
    this.cancellation = value.name;
  }

  closePop() {
    this.confirm = false;
  }
  otxt() {
    this.orderText = false;
  }

  orderCancellation() {
    this.loader = true;
    this.confirm = false;
    var post = {
      cancellationReasons: this.cancellation,
    };
    this.service.cancelOrder(this.cancelId, post).subscribe(
      (res: any) => {
        this.handler.res("Order Cancelled successfully");
        this.confirm = false;
        this.cancellation = "";
        if (this.cancelStatus == 2) {
          this.orderText = true;
        } else {
          this.orderText = false;
        }

        this.ionViewWillEnter();
      },
      (err) => {
        this.loader = false;
        this.confirm = true;
        this.orderText = false;
        this.handler.err(err);
      }
    );
  }

  openPay(id) {
    this.Paymentpop = true;
    this.service.getCustItemSubsById(id).subscribe((res: any) => {
      this.paymentActivity = res;
      this.payAmt = res.payTotal;
      this.paymentActivity.paymentDetails.map((dat) => {
        if (dat) {
          this.monthObj.map((dat1) => {
            if (dat.month == dat1.id) {
              Object.assign(dat, { monthName: dat1.name });
            }
          });
        }
      });
    });
  }
  openOrderPay(data) {
    if ((data.paymtStatus == 1 || data.paymtStatus == 3) && data.status != 5) {
      sessionStorage.setItem("PayCost", data.orderAmountStr);
      this.router.navigate(["/pending-pay/" + data.id]);
    }
  }

  viewBookingDetails(id, data) {
    sessionStorage.setItem("orderType", data);
    this.loader = true;
    this.router.navigate(["saved-items/", +id]);
  }

  savedOrders() {
    this.savesPop = true;
    this.change = false;
  }

  closeSavedPop() {
    this.savesPop = false;
    this.router.navigate(["/mybookings1"]);
  }
  checkPreview() {
    this.Oid = localStorage.getItem("organizationId");
    this.openSlot = true;
    this.slotClicked = false;
    var post = {
      targetCenterId: this.Oid,
      targetSource: this.Oid,
      schElements: [1],
      requestDate: this.fDate,
      status: ["SlotsAvailable"],
      independentEntities: true,
      slotDuration: 15,
    };
    this.service.getTimeSlots(this.slotDate, post).subscribe((res: any) => {
      if (res) {
        this.availableSlots = res;
        this.availSlot = true;
        this.slotClicked = true;
      } else {
        this.handler.res("No Available Slots");
        this.availSlot = false;
        this.slotClicked = true;
      }
    });
  }

  rescheduleOrder() {
    this.rescheduleOrd = false;
    this.loader = true;
    var post = {
      apptDate: this.fDate,
      apptTime: this.time,
      apptEndTime: this.slot.endTime,
      requestDates: [
        {
          apptDate: this.fDate,
          apptTime: this.time,
          apptEndTime: this.slot.endTime,
          status: 1,
        },
      ],
    };
    this.service.rescheduleOrder(this.rescheduleId, post).subscribe(
      (res: any) => {
        this.handler.res("Order Rescheduled Successfully!!");
        this.startdate = undefined;
        this.startdate = "";
        this.changeDate = false;
        this.time = "TIME";
        this.rescheduleOrd = false;
        this.ionViewWillEnter();
      },
      (err) => {
        this.loader = false;
        this.handler.err(err);
      }
    );
  }
  blockDate() {
    // Block From Date
    var someDate = new Date();
    var numberOfFromDaysToAdd = 1;
    someDate.setDate(someDate.getDate() + numberOfFromDaysToAdd);
    var dd = someDate.getDate();
    var mm = someDate.getMonth() + 1;
    var month = mm - 1;
    var y = someDate.getFullYear();
    this.fdateCheck = new Date(y, month, dd);
  }
  openpage() {
    this.iab.create("http://app.oteller.in/Yessboss/#/policy", "_system");
  }
}
